var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 275.01,
    height: 58.068,
    viewBox: "0 0 275.01 58.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 275.01,
    height: 58.068,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M137.577,105.189a30.414,30.414,0,0,1-8.23-1.3l.52-1.733c7.277,2.079,12.822,1.473,14.468-1.386,2.253-3.985-2.945-11.869-12.3-18.367l1.04-1.473c10.4,7.277,15.681,15.768,12.822,20.706-1.386,2.339-4.332,3.552-8.317,3.552",
    transform: "translate(-98.331 -61.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M14.774,65.121A40.157,40.157,0,0,1,4.291,54.552c-2.425-3.812-2.945-7.1-1.473-9.617,2.339-3.985,9.356-4.592,18.367-1.646l-.607,1.733c-8.057-2.6-14.382-2.253-16.2.867-2.253,3.9,2.6,11.349,11.522,17.76Z",
    transform: "translate(-1.519 -31.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M129.23,40.363c-.173-.606-.433-1.3-.607-1.819l1.646-.606c.26.606.433,1.3.693,1.906Z",
    transform: "translate(-97.781 -28.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M63.737,53.541c-3.206,0-6.064-2.859-8.23-8.144A51.694,51.694,0,0,1,52.388,26.77,52.03,52.03,0,0,1,55.507,8.144C57.673,2.946,60.532,0,63.737,0c1.992,0,3.985,1.213,5.631,3.379L67.9,4.418c-.953-1.213-2.426-2.686-4.245-2.686-2.339,0-4.765,2.513-6.584,7.017a50.049,50.049,0,0,0-3.032,17.934c0,6.758,1.04,13.169,3.032,17.934,1.82,4.418,4.158,7.017,6.584,7.017,2.946,0,5.891-3.985,7.711-10.309l1.733.52c-2.079,7.45-5.458,11.7-9.357,11.7",
    transform: "translate(-39.826 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M19.451,82.192l-1.386-1.126a50.322,50.322,0,0,1,14.208-11.7l.866,1.559A45.409,45.409,0,0,0,19.451,82.192",
    transform: "translate(-13.733 -52.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M10.967,150.509c-3.985,0-6.931-1.213-8.317-3.552a7.474,7.474,0,0,1-.087-6.411l1.646.606q-1.17,2.989,0,4.938c1.126,1.906,3.725,2.512,5.718,2.6a29.471,29.471,0,0,0,10.829-1.82l.607,1.733a33.631,33.631,0,0,1-10.4,1.906",
    transform: "translate(-1.437 -106.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M137.261,65.265l-1.04-1.473c4.505-3.205,8.23-6.844,10.309-10.223,2.079-3.205,2.6-6.064,1.559-7.884-1.559-2.686-6.671-3.379-13.255-1.733L134.4,42.22a26.046,26.046,0,0,1,9.357-.78c2.859.433,4.852,1.559,5.891,3.379,1.473,2.512.866,5.891-1.559,9.7a38.637,38.637,0,0,1-10.829,10.743",
    transform: "translate(-102.174 -31.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M117.361,18.3a3.552,3.552,0,1,1,3.552-3.552,3.626,3.626,0,0,1-3.552,3.552m0-5.285a1.733,1.733,0,1,0,1.733,1.733,1.738,1.738,0,0,0-1.733-1.733",
    transform: "translate(-86.519 -8.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M3.552,123.082a3.552,3.552,0,1,1,0-7.1,3.552,3.552,0,1,1,0,7.1m0-5.285a1.733,1.733,0,1,0,1.733,1.733A1.738,1.738,0,0,0,3.552,117.8",
    transform: "translate(0 -88.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M55.694,112.461a1.029,1.029,0,0,1-1.04-.866,62.237,62.237,0,0,1-1.386-6.757,51.714,51.714,0,0,1-.52-7.364v-.26l.087-.173A11.019,11.019,0,0,1,54.394,94.7a11.169,11.169,0,0,1,2.859-2.426,8.18,8.18,0,0,1,1.992-.866l.346,1.646a7.926,7.926,0,0,0-1.473.78,10.206,10.206,0,0,0-2.339,1.993,12.341,12.341,0,0,0-1.213,1.733A52.463,52.463,0,0,0,56.3,110.3l1.04-.26,1.819-.52.52,1.733-1.82.52a16.876,16.876,0,0,1-1.733.433c-.259.26-.346.26-.432.26",
    transform: "translate(-40.1 -69.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M83.192,76.937h4.158A3.4,3.4,0,0,0,90.3,75.9a4.873,4.873,0,0,0,.693-3.292V51.12c0-1.213.26-2.686-.173-3.812A2.924,2.924,0,0,0,88.3,45.4c-1.3-.087-2.6,0-3.9,0H80.16c-1.3,0-2.686-.087-4.072,0a2.908,2.908,0,0,0-2.6,1.906,9.848,9.848,0,0,0-.26,3.205c-.087,4.852,0,9.616.087,14.468,0,1.213,1.993,1.213,1.906,0-.087-4.159-.087-8.317-.087-12.389,0-1.126,0-2.253.087-3.465a3.556,3.556,0,0,1,.087-.953c.26-1.04,1.386-.866,2.253-.866H87a7.4,7.4,0,0,1,1.386,0c.953.26.78,1.473.78,2.252V73.732c0,1.126-.693,1.3-1.559,1.3H83.279a.955.955,0,1,0-.087,1.906",
    transform: "translate(-55.642 -34.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M73.706,122.487a2.041,2.041,0,0,0,1.04,2.079,2.278,2.278,0,0,0,2.339-.346c.52-.347,1.386-.866,1.992-.433a.826.826,0,0,1,.26,1.04,5.97,5.97,0,0,1-1.386,1.559c-.693.607-1.473,1.126-2.166,1.733a5.793,5.793,0,0,0-1.733,1.82,3.353,3.353,0,0,0-.26,2.252,2.954,2.954,0,0,0,1.473,2.253,5.628,5.628,0,0,0,2.686.346.954.954,0,0,0,0-1.906c-.693,0-1.82.26-2.166-.606a1.5,1.5,0,0,1,.433-1.906c1.473-1.3,3.206-2.339,4.419-3.9a2.948,2.948,0,0,0-.607-4.419,3.144,3.144,0,0,0-3.032,0,7.929,7.929,0,0,0-1.126.693c-.173.087-.087.087-.26.087h0v-.346c.086-1.213-1.82-1.213-1.907,0",
    transform: "translate(-56.032 -92.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M93.924,75.873h1.386a.317.317,0,0,1,.346.346v1.386a.317.317,0,0,1-.346.346H93.924a.317.317,0,0,1-.346-.346V76.219c0-.087.173-.346.346-.346",
    transform: "translate(-71.139 -57.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M93.924,99.358h1.386a.317.317,0,0,1,.346.346v1.386a.317.317,0,0,1-.346.346H93.924a.317.317,0,0,1-.346-.346v-1.3a.4.4,0,0,1,.346-.433",
    transform: "translate(-71.139 -75.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M117.7,99.358h1.386a.317.317,0,0,1,.346.346v1.386a.317.317,0,0,1-.346.346H117.7a.317.317,0,0,1-.346-.346v-1.3c-.087-.26.086-.433.346-.433",
    transform: "translate(-89.196 -75.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M117.885,90.8h-1.126a.78.78,0,1,1,0-1.559h1.126a.78.78,0,0,1,0,1.559",
    transform: "translate(-88.169 -67.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M107.365,100.96a.776.776,0,0,1-.78-.78V99.054a.78.78,0,1,1,1.559,0v1.126a.776.776,0,0,1-.78.78",
    transform: "translate(-81.027 -74.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M117.8,78.472a.776.776,0,0,1-.78-.78v-.26h-.26a.78.78,0,0,1,0-1.559h.953a.776.776,0,0,1,.78.78v.953a.7.7,0,0,1-.693.866",
    transform: "translate(-88.169 -57.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M97.476,80.913H94.358a.78.78,0,0,1,0-1.559H96.7V77.015a.78.78,0,1,1,1.559,0v3.119a.776.776,0,0,1-.78.78",
    transform: "translate(-71.139 -57.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M90.987,159.934a3.552,3.552,0,1,1,3.552-3.552,3.513,3.513,0,0,1-3.552,3.552m0-5.285a1.733,1.733,0,1,0,1.733,1.733,1.685,1.685,0,0,0-1.733-1.733",
    transform: "translate(-66.469 -116.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M273.944,52.791a6.574,6.574,0,0,0-3.085-3.084,10.2,10.2,0,0,0-9.814.281,9.9,9.9,0,0,0-3.645,3.925,13.721,13.721,0,0,0,0,11.5,9.767,9.767,0,0,0,3.645,3.925,11.6,11.6,0,0,0,5.327,1.4,9.064,9.064,0,0,0,6.169-1.963,8.04,8.04,0,0,0,3.085-5.608H264.411V58.118h17.945v5.888a18.838,18.838,0,0,1-2.8,6.449,15.456,15.456,0,0,1-5.608,4.767,17.562,17.562,0,0,1-7.571,1.682,19.084,19.084,0,0,1-8.693-2.243,17.677,17.677,0,0,1-6.169-5.888,19.015,19.015,0,0,1,0-17.385,13.953,13.953,0,0,1,6.169-5.888,18.212,18.212,0,0,1,8.693-2.243,15.354,15.354,0,0,1,9.533,2.8,12.719,12.719,0,0,1,5.608,7.571Z",
    transform: "translate(-189.603 -32.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M414.312,46.246v8.131h11.216V59.7H414.312V68.4H426.93v5.328H407.864V40.918H426.93v5.328Z",
    transform: "translate(-310.063 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M540.254,74h-6.729l-14.86-22.712V74h-6.729V40.918h6.729l14.86,22.712V40.918h6.729Z",
    transform: "translate(-389.179 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M664.551,46.246v8.131h11.216V59.7H664.551V68.4h12.618v5.328H658.1V40.918h19.067v5.328Z",
    transform: "translate(-500.297 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M782.642,40.918v5.328H768.9v8.412h10.654v5.328H768.9V74h-6.729V40.918Z",
    transform: "translate(-579.413 -31.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 6.729,
    height: 33.087,
    transform: "translate(207.715 9.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M928.825,46.246v8.131h11.216V59.7H928.825V68.4h12.618v5.328H922.376V40.918h19.067v5.328Z",
    transform: "translate(-701.201 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1046.026,42.881a15.589,15.589,0,0,1,6.169,5.888,19.082,19.082,0,0,1,2.243,8.692,15.942,15.942,0,0,1-8.412,14.581A20.315,20.315,0,0,1,1036.773,74h-11.5V40.918h11.5a20.315,20.315,0,0,1,9.253,1.963M1044.9,65.593c1.963-1.963,2.8-4.486,2.8-8.131,0-3.365-.841-6.169-2.8-8.131s-4.487-2.8-8.131-2.8h-4.767V68.4h4.767a12.379,12.379,0,0,0,8.131-2.8",
    transform: "translate(-779.428 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M278.979,208.155v2.524h2.871v1.053h-2.871v2.62h3.23v1.065h-4.594V207.09h4.594v1.065Z",
    transform: "translate(-211.046 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M306.626,211.3l2.584,4.151h-1.531L305.8,212.44l-1.759,3.015H302.51l2.584-4.151-2.584-4.163h1.531l1.878,3.027,1.771-3.027h1.532Z",
    transform: "translate(-229.972 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M338.051,212.081v3.374h-1.364V207.14h2.871a3.627,3.627,0,0,1,1.621.329,2.289,2.289,0,0,1,.993.892,2.44,2.44,0,0,1,.329,1.256,2.51,2.51,0,0,1-.3,1.2,2.242,2.242,0,0,1-.957.915,3.552,3.552,0,0,1-1.687.353Zm2.668-1.436a1.366,1.366,0,0,0,.383-1.029,1.383,1.383,0,0,0-.383-1.041,1.611,1.611,0,0,0-1.16-.371h-1.508v2.812h1.508a1.61,1.61,0,0,0,1.16-.371",
    transform: "translate(-255.953 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M370.87,207.236a4.005,4.005,0,0,1,1.537,1.514,4.555,4.555,0,0,1,0,4.385,3.992,3.992,0,0,1-1.537,1.519,4.485,4.485,0,0,1-4.283,0,4.032,4.032,0,0,1-1.543-1.519,4.513,4.513,0,0,1,0-4.385,4.046,4.046,0,0,1,1.543-1.514,4.487,4.487,0,0,1,4.283,0m-3.619,1.071a2.6,2.6,0,0,0-1.011,1.053,3.294,3.294,0,0,0-.365,1.579,3.33,3.33,0,0,0,.365,1.585,2.629,2.629,0,0,0,1.011,1.065,3.061,3.061,0,0,0,2.943,0,2.631,2.631,0,0,0,1.011-1.065,3.333,3.333,0,0,0,.365-1.585,3.3,3.3,0,0,0-.365-1.579,2.6,2.6,0,0,0-1.011-1.053,3.1,3.1,0,0,0-2.943,0",
    transform: "translate(-277.078 -157.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M412.319,215.416h-1.364l-4.1-6.209v6.209h-1.364v-8.327h1.364l4.1,6.2v-6.2h1.364Z",
    transform: "translate(-308.257 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M442.824,208.155v2.524h2.871v1.053h-2.871v2.62h3.23v1.065H441.46V207.09h4.594v1.065Z",
    transform: "translate(-335.603 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M474.434,215.416H473.07l-4.1-6.209v6.209H467.6v-8.327h1.364l4.1,6.2v-6.2h1.364Z",
    transform: "translate(-355.477 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M507.581,207.14V208.2h-2.213v7.25H504V208.2h-2.225V207.14Z",
    transform: "translate(-381.458 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 1.364,
    height: 8.315,
    transform: "translate(127.499 49.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M548.342,213.718h-3.482l-.6,1.7h-1.424l2.979-8.327H547.4l2.979,8.327h-1.436Zm-.371-1.065-1.364-3.912-1.376,3.912Z",
    transform: "translate(-412.673 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M581.024,214.414h2.812v1.041h-4.175V207.14h1.364Z",
    transform: "translate(-440.665 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M621.492,207.343a3.715,3.715,0,0,1,1.5,1.848h-1.639a2.2,2.2,0,0,0-.9-.939,2.7,2.7,0,0,0-1.328-.317,2.9,2.9,0,0,0-1.472.371,2.6,2.6,0,0,0-1.011,1.053,3.3,3.3,0,0,0-.365,1.579,3.332,3.332,0,0,0,.365,1.585,2.59,2.59,0,0,0,1.011,1.059,2.9,2.9,0,0,0,1.472.371,2.61,2.61,0,0,0,1.812-.628,2.676,2.676,0,0,0,.844-1.7h-3.123v-1.065h4.582v1.065a4.107,4.107,0,0,1-4.115,3.565,4.3,4.3,0,0,1-2.142-.544,4.059,4.059,0,0,1-1.537-1.514,4.5,4.5,0,0,1,0-4.379,4.042,4.042,0,0,1,1.543-1.513,4.538,4.538,0,0,1,4.5.108",
    transform: "translate(-467.44 -157.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M659.629,215.455l-2.082-3.374h-.837v3.374h-1.364V207.14h2.871a3.628,3.628,0,0,1,1.621.329,2.291,2.291,0,0,1,.993.892A2.4,2.4,0,0,1,659.091,212l2.2,3.457Zm-2.919-4.438h1.507a1.61,1.61,0,0,0,1.161-.371,1.366,1.366,0,0,0,.383-1.029,1.383,1.383,0,0,0-.383-1.041,1.611,1.611,0,0,0-1.161-.371H656.71Z",
    transform: "translate(-498.202 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M691.376,207.236a4,4,0,0,1,1.537,1.514,4.555,4.555,0,0,1,0,4.385,3.991,3.991,0,0,1-1.537,1.519,4.485,4.485,0,0,1-4.283,0,4.031,4.031,0,0,1-1.543-1.519,4.513,4.513,0,0,1,0-4.385,4.044,4.044,0,0,1,1.543-1.514,4.487,4.487,0,0,1,4.283,0m-3.619,1.071a2.6,2.6,0,0,0-1.011,1.053,3.3,3.3,0,0,0-.365,1.579,3.333,3.333,0,0,0,.365,1.585,2.631,2.631,0,0,0,1.011,1.065,3.06,3.06,0,0,0,2.943,0,2.628,2.628,0,0,0,1.011-1.065,3.331,3.331,0,0,0,.365-1.585,3.3,3.3,0,0,0-.365-1.579,2.6,2.6,0,0,0-1.011-1.053,3.1,3.1,0,0,0-2.943,0",
    transform: "translate(-520.731 -157.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M734.7,207.14l-2.464,8.315h-1.544l-1.747-6.293-1.854,6.293-1.531.012L723.2,207.14h1.448l1.723,6.771,1.866-6.771h1.531l1.735,6.736,1.735-6.736Z",
    transform: "translate(-549.784 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M779.842,207.14V208.2h-2.213v7.25h-1.364V208.2h-2.225V207.14Z",
    transform: "translate(-588.434 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M810.615,207.14v8.315h-1.364v-3.673h-3.912v3.673h-1.364V207.14h1.364v3.589h3.912V207.14Z",
    transform: "translate(-611.192 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M857.573,213.718h-3.481l-.6,1.7H852.07l2.979-8.327h1.579l2.979,8.327h-1.436Zm-.371-1.065-1.364-3.912-1.376,3.912Z",
    transform: "translate(-647.754 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M893.59,213.942a2.49,2.49,0,0,1-1,.909,3.264,3.264,0,0,1-1.544.347,3.394,3.394,0,0,1-2.093-.61,1.991,1.991,0,0,1-.814-1.687h1.46a1.276,1.276,0,0,0,.407.874,1.506,1.506,0,0,0,1.041.323,1.6,1.6,0,0,0,1.107-.359,1.181,1.181,0,0,0,.4-.921.972.972,0,0,0-.246-.7,1.612,1.612,0,0,0-.616-.395,9.414,9.414,0,0,0-1.017-.293,8.664,8.664,0,0,1-1.316-.4,2.115,2.115,0,0,1-.861-.67,1.982,1.982,0,0,1-.359-1.25,2.267,2.267,0,0,1,.359-1.268,2.341,2.341,0,0,1,1.005-.849,3.5,3.5,0,0,1,1.483-.3,3.144,3.144,0,0,1,1.968.574,2.2,2.2,0,0,1,.832,1.663H892.28a1.207,1.207,0,0,0-.407-.8,1.376,1.376,0,0,0-.957-.323,1.545,1.545,0,0,0-1,.311,1.117,1.117,0,0,0-.383.921,1.016,1.016,0,0,0,.245.712,1.543,1.543,0,0,0,.616.407,9.134,9.134,0,0,0,1.029.293,8.791,8.791,0,0,1,1.3.4,2.113,2.113,0,0,1,.855.658,1.955,1.955,0,0,1,.353,1.238,2.268,2.268,0,0,1-.341,1.2",
    transform: "translate(-675.174 -157.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M938.692,213.942a2.49,2.49,0,0,1-1,.909,3.264,3.264,0,0,1-1.543.347,3.394,3.394,0,0,1-2.093-.61,1.99,1.99,0,0,1-.814-1.687h1.46a1.275,1.275,0,0,0,.407.874,1.506,1.506,0,0,0,1.041.323,1.6,1.6,0,0,0,1.107-.359,1.181,1.181,0,0,0,.4-.921.972.972,0,0,0-.246-.7,1.613,1.613,0,0,0-.616-.395,9.406,9.406,0,0,0-1.017-.293,8.664,8.664,0,0,1-1.316-.4,2.114,2.114,0,0,1-.861-.67,1.982,1.982,0,0,1-.359-1.25,2.268,2.268,0,0,1,.359-1.268,2.34,2.34,0,0,1,1-.849,3.5,3.5,0,0,1,1.483-.3,3.143,3.143,0,0,1,1.968.574,2.2,2.2,0,0,1,.832,1.663h-1.507a1.208,1.208,0,0,0-.407-.8,1.376,1.376,0,0,0-.957-.323,1.545,1.545,0,0,0-1,.311,1.117,1.117,0,0,0-.383.921,1.016,1.016,0,0,0,.245.712,1.543,1.543,0,0,0,.616.407,9.13,9.13,0,0,0,1.029.293,8.791,8.791,0,0,1,1.3.4,2.112,2.112,0,0,1,.855.658,1.955,1.955,0,0,1,.353,1.238,2.269,2.269,0,0,1-.341,1.2",
    transform: "translate(-709.461 -157.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M965.49,208.155v2.524h2.871v1.053H965.49v2.62h3.23v1.065h-4.594V207.09h4.594v1.065Z",
    transform: "translate(-732.94 -157.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M994.553,215.455l-2.082-3.374h-.837v3.374H990.27V207.14h2.871a3.628,3.628,0,0,1,1.621.329,2.291,2.291,0,0,1,.993.892A2.4,2.4,0,0,1,994.015,212l2.2,3.457Zm-2.919-4.438h1.507a1.61,1.61,0,0,0,1.161-.371,1.366,1.366,0,0,0,.383-1.029,1.383,1.383,0,0,0-.383-1.041,1.611,1.611,0,0,0-1.161-.371h-1.507Z",
    transform: "translate(-752.815 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1020.466,207.14l2.453,6.9,2.476-6.9h1.448l-3.123,8.315h-1.579l-3.134-8.315Z",
    transform: "translate(-774.661 -157.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1.364,
    height: 8.315,
    transform: "translate(253.319 49.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1074.311,207.343a3.713,3.713,0,0,1,1.5,1.848h-1.639a2.2,2.2,0,0,0-.9-.939,2.7,2.7,0,0,0-1.328-.317,2.9,2.9,0,0,0-1.472.371,2.6,2.6,0,0,0-1.011,1.053,3.294,3.294,0,0,0-.365,1.579,3.33,3.33,0,0,0,.365,1.585,2.589,2.589,0,0,0,1.011,1.059,2.9,2.9,0,0,0,1.472.371,2.7,2.7,0,0,0,1.328-.317,2.2,2.2,0,0,0,.9-.939h1.639a3.682,3.682,0,0,1-1.5,1.843,4.369,4.369,0,0,1-2.363.646,4.3,4.3,0,0,1-2.142-.544,4.059,4.059,0,0,1-1.537-1.514,4.5,4.5,0,0,1,0-4.379,4.042,4.042,0,0,1,1.543-1.513,4.537,4.537,0,0,1,4.5.108",
    transform: "translate(-811.679 -157.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1109.527,208.155v2.524h2.872v1.053h-2.872v2.62h3.23v1.065h-4.594V207.09h4.594v1.065Z",
    transform: "translate(-842.439 -157.432)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdmin);
export default __webpack_public_path__ + "static/media/logo-admin.bd76f4821bcd14a3386b947a1c981900.svg";
export { ForwardRef as ReactComponent };